
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("1gsg0", function(module, exports) {
/**
 * @Relay no-runtime
 */ /**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $xQxzY = parcelRequire("xQxzY");


var $T1bCI = parcelRequire("T1bCI");


var $cbc8g = parcelRequire("cbc8g");


var $6bHqX = parcelRequire("6bHqX");


var $1o4fX = parcelRequire("1o4fX");


var $euL71 = parcelRequire("euL71");


var $hrAmX = parcelRequire("hrAmX");


var $bQm3c = parcelRequire("bQm3c");


var $9wGTI = parcelRequire("9wGTI");


var $1ytiN = parcelRequire("1ytiN");


var $3IBnw = parcelRequire("3IBnw");


var $hSqtY = parcelRequire("hSqtY");


var $1uFM6 = parcelRequire("1uFM6");


var $irVI7 = parcelRequire("irVI7");


var $a1uvs = parcelRequire("a1uvs");

var $gfIPU = parcelRequire("gfIPU");

var $1eaCJ = parcelRequire("1eaCJ");

var $1kHsc = parcelRequire("1kHsc");


var $ivb8S = parcelRequire("ivb8S");


var $6eN5W = parcelRequire("6eN5W");


var $7Sm4c = parcelRequire("7Sm4c");


var $kPeHn = parcelRequire("kPeHn");


var $iTy4g = parcelRequire("iTy4g");


var $iuUMQ = parcelRequire("iuUMQ");


var $8JJsY = parcelRequire("8JJsY");


var $gqp7m = parcelRequire("gqp7m");


var $7XaXR = parcelRequire("7XaXR");


var $hY10E = parcelRequire("hY10E");


var $53KZp = parcelRequire("53KZp");


var $5lbXZ = parcelRequire("5lbXZ");

const $b74bf660cb1e22de$var$DAYS_TO_DEACTIVATION = 14;
const $b74bf660cb1e22de$export$8f84b2734337bf99 = ({ trialEndDate: trialEndDate })=>{
    const date = new Date(trialEndDate);
    date.setDate(date.getDate() + $b74bf660cb1e22de$var$DAYS_TO_DEACTIVATION);
    return {
        dateString: date.toLocaleDateString(undefined, {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        }),
        date: date
    };
};


/* NonCompliantBannerMessage.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gMc0m = parcelRequire("gMc0m");





var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $dWCFT = parcelRequire("dWCFT");


var $eEA8O = parcelRequire("eEA8O");


var $9VJDA = parcelRequire("9VJDA");


var $52EPl = parcelRequire("52EPl");

var $dAYOx = parcelRequire("dAYOx");

var $ahaN7 = parcelRequire("ahaN7");


var $inPa6 = parcelRequire("inPa6");


var $53qVZ = parcelRequire("53qVZ");





var $cN2XO = parcelRequire("cN2XO");


var $1gsg0 = parcelRequire("1gsg0");

const $ec4f0bb7d2875a45$var$i18n = (0, $cgtv4.defineMessages)({
    deactivationWarning: {
        id: "trial-components.banner.warning.deactivation",
        defaultMessage: "Your trial has ended and you\u2019ve exceeded the user limit. This site will be deactivated on {deactivationDateLong} unless you add billing information to upgrade, or remove {numberOfUsersToDelete, plural, one {# user} other {# users}}."
    },
    linkToAddBillingV2: {
        id: "trial-components.banner.add-billing.link.v2",
        defaultMessage: "Add payment details"
    },
    linkToLearnMore: {
        id: "trial-components.banner.learn-more.link",
        defaultMessage: "Learn more"
    },
    reverseTrialsChooseAPlan: {
        id: "trial-components.banner.non-compliant.reverse-trials.choose-a-plan",
        defaultMessage: "Your trial has ended and you\u2019ve exceeded the Free user limit. <choosePlanLink>Choose a paid plan</choosePlanLink> or <removeUsersLink>remove users</removeUsersLink> to prevent site deactivation on {deactivationDateLong}."
    }
});
const $ec4f0bb7d2875a45$var$LEARN_MORE_LINK = 'https://support.atlassian.com/confluence-cloud/docs/removing-users-and-downgrading-to-confluence-free';
const $ec4f0bb7d2875a45$var$inlineLinkCSS = null;
const $ec4f0bb7d2875a45$export$c715243965c2f8cf = ({ linkToAddBilling: linkToAddBilling, deactivationDate: deactivationDate, numberOfUsersOverFreeLimit: numberOfUsersOverFreeLimit, licenseConsumingUserCount: licenseConsumingUserCount, edition: edition, premiumReverseTrialABCohort: premiumReverseTrialABCohort, linkToChoosePlan: linkToChoosePlan })=>{
    const { orgId: orgId, environment: environment } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'gracePeriodBanner',
                attributes: {
                    deactivationDate: deactivationDate,
                    licenseConsumingUserCount: licenseConsumingUserCount,
                    edition: edition,
                    premiumReverseTrialABCohort: premiumReverseTrialABCohort
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        deactivationDate,
        licenseConsumingUserCount,
        edition,
        premiumReverseTrialABCohort
    ]);
    const onBillingClicked = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'gracePeriodBannerBilling',
                source: 'gracePeriodBanner',
                attributes: {
                    deactivationDate: deactivationDate,
                    licenseConsumingUserCount: licenseConsumingUserCount,
                    edition: edition,
                    premiumReverseTrialABCohort: premiumReverseTrialABCohort
                }
            }
        }).fire();
    };
    const onChoosePlanClicked = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'gracePeriodBannerChoosePlanCTA',
                source: 'gracePeriodBanner',
                attributes: {
                    deactivationDate: deactivationDate,
                    licenseConsumingUserCount: licenseConsumingUserCount,
                    premiumReverseTrialABCohort: premiumReverseTrialABCohort
                }
            }
        }).fire();
    };
    const onRemoveUsersClicked = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'gracePeriodBannerRemoveUsers',
                source: 'gracePeriodBanner',
                attributes: {
                    deactivationDate: deactivationDate,
                    licenseConsumingUserCount: licenseConsumingUserCount,
                    edition: edition,
                    premiumReverseTrialABCohort: premiumReverseTrialABCohort
                }
            }
        }).fire();
    };
    const onDropdownClicked = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'gracePeriodBannerDropDown',
                source: 'gracePeriodBanner'
            }
        }).fire();
    };
    const onLearnMoreClicked = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'gracePeriodBannerLearnMore',
                source: 'gracePeriodBanner'
            }
        }).fire();
    };
    if (premiumReverseTrialABCohort === 'variation') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $53qVZ.OnboardingWarningBanner), {
        bannerHeight: (0, $1gsg0.NON_COMPLIANT_BANNER_HEIGHT),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
            ...$ec4f0bb7d2875a45$var$i18n.reverseTrialsChooseAPlan,
            values: {
                deactivationDateLong: (0, $dWCFT.default)(new Date(deactivationDate), 'MMMM d, yyyy'),
                choosePlanLink: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $53qVZ.BannerLink), {
                        href: linkToChoosePlan,
                        target: "_blank",
                        onClick: onChoosePlanClicked,
                        className: (0, $gMc0m.default)([
                            "_1dltidpf _w8sqidpf _fjwridpf _1yxxidpf"
                        ])
                    }, chunks),
                removeUsersLink: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $53qVZ.BannerLink), {
                        href: (0, $cN2XO.linkToAdminHubOrg)(environment, orgId, '/users?status=ACTIVE'),
                        target: "_blank",
                        onClick: onRemoveUsersClicked,
                        className: (0, $gMc0m.default)([
                            "_1dltidpf _w8sqidpf _fjwridpf _1yxxidpf"
                        ])
                    }, chunks)
            }
        })
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $53qVZ.OnboardingWarningBanner), {
        bannerHeight: (0, $1gsg0.NON_COMPLIANT_BANNER_HEIGHT),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
            ...$ec4f0bb7d2875a45$var$i18n.deactivationWarning,
            values: {
                deactivationDateLong: deactivationDate,
                numberOfUsersToDelete: numberOfUsersOverFreeLimit
            }
        }),
        inlineDescriptionCTA: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $53qVZ.BannerLink), {
            href: linkToAddBilling,
            target: "_blank",
            onClick: onBillingClicked
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $ec4f0bb7d2875a45$var$i18n.linkToAddBillingV2)),
        rightSideComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $52EPl.default), {
            trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
                    ...props,
                    appearance: "subtle",
                    iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))), {
                        label: "more"
                    }),
                    ref: triggerRef,
                    onClick: (e)=>{
                        if (props.onClick) props.onClick(e);
                        onDropdownClicked();
                    }
                })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ahaN7.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
            onClick: ()=>{
                window.open($ec4f0bb7d2875a45$var$LEARN_MORE_LINK, '_blank');
                onLearnMoreClicked();
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $ec4f0bb7d2875a45$var$i18n.linkToLearnMore))))
    });
};


/* CompliantBannerMessage.tsx generated by @compiled/babel-plugin v0.36.1 */ 










var $8C5kA = parcelRequire("8C5kA");





var $hmuev = parcelRequire("hmuev");







/* CompliantWarningBanner.tsx generated by @compiled/babel-plugin v0.36.1 */ 





var $7sObp = parcelRequire("7sObp");







var $eXmBZ = parcelRequire("eXmBZ");

const $32d27a5f511104be$var$BannerContentContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1neqek2": (0, $7sObp.default)(`${__cmplp.height}px`)
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11q71s93 _1yt4utpp _zulp1b66 _1e0c1txw _1bah1h6o _4cvr1h6o _4t3i2nrh _vchhusvi",
            __cmplp.className
        ])
    });
});
const $32d27a5f511104be$export$aa2fe30df074b213 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_4bfu1r31 _1hms8stv _ajmmnqa1 _syazi7uo _80omtlke _o5721q9c _d16pv77o _7b0b1i6y _30l3i7uo _1053i7uo",
            __cmplp.className
        ])
    });
});
const $32d27a5f511104be$var$TextContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _zulp1b66 _1e0c1txw _4cvr1h6o _k48p1wq8",
            __cmplp.className
        ])
    });
});
const $32d27a5f511104be$var$DescriptionContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
});
const $32d27a5f511104be$var$i18n = (0, $cgtv4.defineMessages)({
    infoIcon: {
        id: "trial-components.icons.info",
        defaultMessage: "Information icon"
    }
});
const $32d27a5f511104be$export$5c356aa1d7ea4215 = ({ bannerHeight: bannerHeight, description: description, inlineDescriptionCTA: inlineDescriptionCTA, rightSideComponent: rightSideComponent })=>{
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($32d27a5f511104be$var$BannerContentContainer, {
        height: bannerHeight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($32d27a5f511104be$var$TextContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eXmBZ))), {
        label: formatMessage($32d27a5f511104be$var$i18n.infoIcon),
        color: "var(--ds-icon, #292A2E)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($32d27a5f511104be$var$DescriptionContainer, null, description), inlineDescriptionCTA), rightSideComponent);
};





const $b7ccc1702405ac49$var$i18n = (0, $cgtv4.defineMessages)({
    trialEndedWarning: {
        id: "trial-components.trial.ended.warning",
        defaultMessage: "Your trial has ended."
    },
    remainingDaysWarning: {
        id: "trial-components.trial.ended.remaining.days.warning",
        defaultMessage: "We\u2019re giving you an extra {numberOfDaysLeft, plural, one {# day} other {# days}} to keep all {edition} features."
    },
    lastDayWarning: {
        id: "trial-components.trial.ended.last.day.warning",
        defaultMessage: "Today is the last day to keep all {edition} features."
    },
    linkToPaymentDetails: {
        id: "trial-components.banner.trial.ended.link-to-payment-details",
        defaultMessage: "Add payment details to stay on {edition}."
    },
    dismissIcon: {
        id: "trial-components.banner.icons.dismiss",
        defaultMessage: "Dismiss button with cross icon"
    },
    reverseTrialsChooseAPlanMessage: {
        id: "trial-components.banner.compliant.reverse-trials.choose-a-plan.message",
        defaultMessage: "Your trial has ended. We\u2019re giving you {numberOfDaysLeft, plural, one {# day} other {# days}} to keep all features so you can choose the right plan for your team."
    },
    reverseTrialsChooseAPlanCTA: {
        id: "trial-components.banner.compliant.reverse-trials.choose-a-plan.cta",
        defaultMessage: "Choose plan now"
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b7ccc1702405ac49$var$IconWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_80omtlke",
            __cmplp.className
        ])
    });
});
const $b7ccc1702405ac49$var$capitalize = (string)=>{
    const lowerCaseString = string.toLowerCase();
    return lowerCaseString.charAt(0).toUpperCase() + lowerCaseString.slice(1);
};
const $b7ccc1702405ac49$export$f65c9f2c373ce883 = ({ linkToAddBilling: linkToAddBilling, daysLeftUntilDeactivation: daysLeftUntilDeactivation, licenseConsumingUserCount: licenseConsumingUserCount, edition: edition, hideBanner: hideBanner, premiumReverseTrialABCohort: premiumReverseTrialABCohort, linkToChoosePlan: linkToChoosePlan })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    (0, $42omo.useEffect)(()=>{
        if (premiumReverseTrialABCohort) createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'compliantGracePeriodBanner',
                attributes: {
                    daysLeft: daysLeftUntilDeactivation,
                    licenseConsumingUserCount: licenseConsumingUserCount,
                    edition: edition,
                    premiumReverseTrialABCohort: premiumReverseTrialABCohort
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        daysLeftUntilDeactivation,
        licenseConsumingUserCount,
        edition,
        premiumReverseTrialABCohort
    ]);
    const onBillingClicked = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'gracePeriodBannerBilling',
                source: 'compliantGracePeriodBanner',
                attributes: {
                    daysLeft: daysLeftUntilDeactivation,
                    licenseConsumingUserCount: licenseConsumingUserCount,
                    edition: edition,
                    premiumReverseTrialABCohort: premiumReverseTrialABCohort
                }
            }
        }).fire();
    };
    const onChoosePlanClicked = ()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'compliantGracePeriodBannerChoosePlanCTA',
                source: 'compliantGracePeriodBanner',
                attributes: {
                    daysLeft: daysLeftUntilDeactivation,
                    licenseConsumingUserCount: licenseConsumingUserCount,
                    premiumReverseTrialABCohort: premiumReverseTrialABCohort
                }
            }
        }).fire();
    };
    const onDismiss = ()=>{
        setOnboardingState({
            key: (0, $6eN5W.TRIAL_COMPONENTS_EXPERIENCES).GRACE_PERIOD_BANNER_DISMISSED,
            value: 'true'
        });
        hideBanner();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'dismissed',
                actionSubject: 'button',
                actionSubjectId: 'compliantGracePeriodBanner',
                source: 'compliantGracePeriodBanner',
                attributes: {
                    daysLeft: daysLeftUntilDeactivation,
                    licenseConsumingUserCount: licenseConsumingUserCount,
                    edition: edition,
                    premiumReverseTrialABCohort: premiumReverseTrialABCohort
                }
            }
        }).fire();
    };
    const handleKeyDown = (e)=>{
        // can select an option with either Enter or spacebar
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onDismiss();
        }
    };
    if (daysLeftUntilDeactivation === undefined || isNaN(daysLeftUntilDeactivation) || daysLeftUntilDeactivation < 0) return null;
    if (premiumReverseTrialABCohort === 'variation') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $32d27a5f511104be$export$5c356aa1d7ea4215), {
        bannerHeight: (0, $1gsg0.COMPLIANT_BANNER_HEIGHT),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
            ...$b7ccc1702405ac49$var$i18n.reverseTrialsChooseAPlanMessage,
            values: {
                numberOfDaysLeft: daysLeftUntilDeactivation
            }
        }),
        inlineDescriptionCTA: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $32d27a5f511104be$export$aa2fe30df074b213), {
            href: linkToChoosePlan,
            target: "_blank",
            onClick: onChoosePlanClicked
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $b7ccc1702405ac49$var$i18n.reverseTrialsChooseAPlanCTA)),
        rightSideComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b7ccc1702405ac49$var$IconWrapper, {
            onClick: onDismiss,
            tabIndex: 0,
            "data-testid": "banner-dismiss-icon",
            onKeyDown: handleKeyDown
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
            label: formatMessage($b7ccc1702405ac49$var$i18n.dismissIcon)
        }))
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $32d27a5f511104be$export$5c356aa1d7ea4215), {
        bannerHeight: (0, $1gsg0.COMPLIANT_BANNER_HEIGHT),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $b7ccc1702405ac49$var$i18n.trialEndedWarning), ' ', daysLeftUntilDeactivation === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
            ...$b7ccc1702405ac49$var$i18n.lastDayWarning,
            values: {
                edition: $b7ccc1702405ac49$var$capitalize(edition)
            }
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
            ...$b7ccc1702405ac49$var$i18n.remainingDaysWarning,
            values: {
                numberOfDaysLeft: daysLeftUntilDeactivation,
                edition: $b7ccc1702405ac49$var$capitalize(edition)
            }
        })),
        inlineDescriptionCTA: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $32d27a5f511104be$export$aa2fe30df074b213), {
            href: linkToAddBilling,
            target: "_blank",
            onClick: onBillingClicked
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
            ...$b7ccc1702405ac49$var$i18n.linkToPaymentDetails,
            values: {
                edition: $b7ccc1702405ac49$var$capitalize(edition)
            }
        })),
        rightSideComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b7ccc1702405ac49$var$IconWrapper, {
            onClick: onDismiss,
            tabIndex: 0,
            "data-testid": "banner-dismiss-icon",
            onKeyDown: handleKeyDown
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
            label: formatMessage($b7ccc1702405ac49$var$i18n.dismissIcon)
        }))
    });
};





/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");










var $bYRk6 = parcelRequire("bYRk6");


var $ebrpi = parcelRequire("ebrpi");


var $6f0Oj = parcelRequire("6f0Oj");

var $bUlM5 = parcelRequire("bUlM5");

var $dcJ7R = parcelRequire("dcJ7R");

var $ecnYn = parcelRequire("ecnYn");


var $iXCQx = parcelRequire("iXCQx");


var $5EhYK = parcelRequire("5EhYK");


var $dhYWb = parcelRequire("dhYWb");


var $b0bCf = parcelRequire("b0bCf");


var $4LS1B = parcelRequire("4LS1B");

const $0ac82697a5fdf93e$var$WrapperStyle = (0, $ecnYn.xcss)({
    padding: 'space.150',
    alignItems: 'center',
    justifyContent: 'space-between',
    overflow: 'hidden',
    background: "var(--ds-background-warning-bold, #FBC828)",
    height: '44px'
});
const $0ac82697a5fdf93e$var$InlineStyles = (0, $ecnYn.xcss)({
    alignItems: 'center'
});
const $0ac82697a5fdf93e$var$linkStyles = {
    modalTakeAction: "_1hms8stv"
};
function $0ac82697a5fdf93e$export$efca1d277cbcb6a({ baseProduct: baseProduct, autoUpgradedJiraSubProducts: autoUpgradedJiraSubProducts, cloudId: cloudId }) {
    const { growthErrorHandler: growthErrorHandler } = (0, $5EhYK.useAnalytics)();
    const { formatList: formatList } = (0, $8C5kA.default)();
    const errorCallback = (0, $42omo.useCallback)(({ error: error, errorInfo: errorInfo })=>{
        growthErrorHandler({
            error: error,
            errorInfo: errorInfo,
            product: baseProduct,
            source: (0, $dhYWb.AVOID_DEACTIVATION_BANNER_SUBJECT_ID)
        });
    }, [
        baseProduct,
        growthErrorHandler
    ]);
    const takeActionFormattedMessageValue = /*#__PURE__*/ (0, $l998X.jsx)((0, $4LS1B.AutoUpgradeAvoidDeactivationModal), {
        product: autoUpgradedJiraSubProducts !== undefined ? autoUpgradedJiraSubProducts[0] : baseProduct,
        touchpointId: "avoid-deactivation-banner",
        cloudId: cloudId,
        onError: errorCallback,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
            weight: "bold",
            xcss: $0ac82697a5fdf93e$var$linkStyles.modalTakeAction,
            testId: `${(0, $dhYWb.AVOID_DEACTIVATION_BANNER_TEST_ID)}-take-action-button`,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                id: "@atlassian/auto-upgrade-not-a-trial.avoid-deactivation-banner.take-action-link",
                defaultMessage: "Take action"
            })
        })
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $bYRk6.default), {
        data: {
            attributes: {
                baseProduct: baseProduct,
                autoUpgradedJiraSubProducts: autoUpgradedJiraSubProducts,
                touchpointId: (0, $dhYWb.AVOID_DEACTIVATION_BANNER_SUBJECT_ID)
            }
        },
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $bUlM5.default), {
            testId: (0, $dhYWb.AVOID_DEACTIVATION_BANNER_TEST_ID),
            xcss: $0ac82697a5fdf93e$var$WrapperStyle,
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $dcJ7R.default), {
                space: "space.200",
                xcss: $0ac82697a5fdf93e$var$InlineStyles,
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ebrpi))), {
                        color: "var(--ds-text, #292A2E)",
                        label: "deactivation date warning icon",
                        testId: `${(0, $dhYWb.AVOID_DEACTIVATION_BANNER_TEST_ID)}-warning-icon`
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                        children: baseProduct === 'confluence' || autoUpgradedJiraSubProducts === undefined ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                            id: "@atlassian/auto-upgrade-not-a-trial.avoid-deactivation-banner.banner-message-take-action",
                            defaultMessage: "You\u2019re over the Free user limit, so we\u2019ve temporarily moved you onto the Standard plan. Take action to avoid site deactivation. {takeAction}",
                            values: {
                                takeAction: takeActionFormattedMessageValue
                            }
                        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                            id: "@atlassian/auto-upgrade-not-a-trial.avoid-deactivation-banner.banner-message-take-action-product-specific",
                            defaultMessage: "{productsList} {numProducts, plural, one {is} other {are}} over the Free user limit, so we\u2019ve temporarily moved you onto the Standard plan. Take action to avoid site deactivation. {takeAction}",
                            values: {
                                takeAction: takeActionFormattedMessageValue,
                                productsList: formatList(autoUpgradedJiraSubProducts.map((product)=>(0, $b0bCf.getProductNameFromProductKey)(product)), {
                                    style: 'long',
                                    type: 'conjunction'
                                }),
                                numProducts: autoUpgradedJiraSubProducts.length
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $5EhYK.ScreenEvent), {
                        name: (0, $dhYWb.AVOID_DEACTIVATION_BANNER_SUBJECT_ID),
                        attributes: {
                            baseProduct: baseProduct,
                            autoUpgradedJiraSubProducts: autoUpgradedJiraSubProducts
                        }
                    })
                ]
            })
        })
    });
}



var $gWF6I = parcelRequire("gWF6I");

const $31d8c74f6a420dc4$export$efca1d277cbcb6a = ({ cloudId: cloudId })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gWF6I.RelayEnvironmentProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $0ac82697a5fdf93e$export$efca1d277cbcb6a), {
        baseProduct: "confluence",
        cloudId: cloudId
    }));
};


const $8348e7541d13687e$var$BANNER_NAME = 'GracePeriodBanner';
const $8348e7541d13687e$export$2eff8595d3cf14d9 = 56;
const $8348e7541d13687e$export$16263d008de82112 = 48;
const $8348e7541d13687e$var$FREE_USER_LIMIT = 10;
const $8348e7541d13687e$export$b7f0db819db4d29e = ()=>{
    const { isLicensed: isLicensed, isLoggedIn: isLoggedIn, userId: userId, edition: edition, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const isTrialEdition = edition === (0, $euL71.ConfluenceEdition).STANDARD || edition === (0, $euL71.ConfluenceEdition).PREMIUM;
    const initialSkipConditions = !isLicensed || !isLoggedIn || !userId || !isTrialEdition || !isSiteAdmin;
    (0, $42omo.useEffect)(()=>{
        if (!initialSkipConditions) experienceTracker.start({
            name: (0, $irVI7.ONBOARDING_GRACE_PERIOD_BANNER_EXPERIENCE)
        });
    }, [
        experienceTracker,
        initialSkipConditions
    ]);
    const { commerceBackendName: commerceBackendName, loading: commerceBackendNameLoading, error: commerceBackendNameError } = (0, $kPeHn.useCommerceBackendName)(initialSkipConditions);
    const canSkipTrialDetails = initialSkipConditions || commerceBackendName !== (0, $6bHqX.COMMERCE_BACKEND_CCP);
    const { data: data, loading: onboardingStateLoading, error: onboardingStateError } = (0, $ivb8S.useGetOnboardingState)((0, $6eN5W.TRIAL_COMPONENTS_EXPERIENCES).GRACE_PERIOD_BANNER_DISMISSED, // skip conditions
    canSkipTrialDetails);
    const deserializedState = (0, $ivb8S.deserializeState)(data);
    const { trialGracePeriodBannerDismissed: trialGracePeriodBannerDismissed } = deserializedState;
    const { data: trialDetailsData, loading: trialLoading, error: trialError } = (0, $xQxzY.useQuery)((0, $eSUdr.default)`query GracePeriodBannerTrialDetailsQuery{license{billingSourceSystem licenseConsumingUserCount trialEndDate}}`, {
        skip: canSkipTrialDetails
    });
    const licenseConsumingUserCount = (0, $iuUMQ.getLicenseConsumingUserCountFromQuery)(trialDetailsData);
    const numberOfUsersOverFreeLimit = licenseConsumingUserCount - $8348e7541d13687e$var$FREE_USER_LIMIT;
    const isOverFreeLimit = licenseConsumingUserCount > $8348e7541d13687e$var$FREE_USER_LIMIT;
    const trialEndDate = trialDetailsData?.license?.trialEndDate;
    const trialDaysLeft = (0, $1o4fX.getTrialDaysLeftFromTrialEndDate)(trialEndDate) ?? null;
    const isInTrial = !!trialEndDate && trialDaysLeft !== null && trialDaysLeft > 0;
    const { deactivationDate: preDunningDeactivationDate, isPreDunningPeriod: isPreDunningPeriod, loading: predunningLoading, error: predunningError } = (0, $iTy4g.useIsPreDunningPeriod)({
        skip: canSkipTrialDetails
    });
    let deactivationDate;
    if (isPreDunningPeriod) deactivationDate = preDunningDeactivationDate;
    else deactivationDate = trialEndDate && (0, $b74bf660cb1e22de$export$8f84b2734337bf99)({
        trialEndDate: trialEndDate
    });
    const { hasBillingInformation: hasBillingInformation, loading: billingLoading, error: billingErr } = (0, $gqp7m.useHasBillingInformation)(!deactivationDate);
    const shouldSkipPremiumReverseTrialsCheck = canSkipTrialDetails || edition !== (0, $euL71.ConfluenceEdition).PREMIUM || hasBillingInformation || !(0, $9wGTI.fg)('growth_confluence_buy_reverse_trials_fg');
    const { isReverseTrialer: isReverseTrialer, loading: isReverseTrialLoading, error: isReverseTrialerError } = (0, $hY10E.useReverseTrialCohort)({
        skip: shouldSkipPremiumReverseTrialsCheck
    });
    const { isAvailableToUser: isPlanSelectionPageUrlAvailable, planSelectionPageUrl: planSelectionPageUrl, error: pspUrlError, loading: isPSPUrlLoading } = (0, $53KZp.usePlanSelectionPageInfo)({
        skip: shouldSkipPremiumReverseTrialsCheck
    });
    const isEligibleForPremiumReverseTrialsExperiment = (0, $7XaXR.useIsEligibleForPremiumReverseTrialsExperiment)({
        isReverseTrialer: isReverseTrialer,
        isInPredunning: isPreDunningPeriod,
        edition: edition,
        hasBillingInformation: hasBillingInformation,
        commerceBackendName: commerceBackendName,
        isPlanSelectionPageUrlAvailable: isPlanSelectionPageUrlAvailable
    });
    const premiumReverseTrialABCohort = (0, $7XaXR.usePremiumReverseTrialABCohort)({
        isEligible: isEligibleForPremiumReverseTrialsExperiment,
        touchpointId: 'grace-period-banner',
        attributes: {
            licenseConsumingUserCount: licenseConsumingUserCount,
            deactivationDate: deactivationDate
        }
    });
    const { loading: useAutoUpgradeNotATrialExperimentLoading, error: useAutoUpgradeNotATrialExperimentError, autoUpgradeNotATrialExperimentCohort: autoUpgradeNotATrialExperimentCohort } = (0, $5lbXZ.useAutoUpgradeNotATrialExperiment)({
        isSiteAdmin: isSiteAdmin,
        edition: edition,
        hasBillingInformation: hasBillingInformation,
        isInTrialOrPredunning: isInTrial || isPreDunningPeriod,
        commerceBackendName: commerceBackendName,
        source: 'confluence_grace_period_banner',
        skip: canSkipTrialDetails || !(0, $9wGTI.fg)('auto_upgrade_not_a_trial_experiment_connie_gate'),
        analyticAttributes: {
            trialDaysLeft: trialDaysLeft
        }
    });
    const canSkipBillingUrl = !isPreDunningPeriod || !deactivationDate;
    const { paymentFlowUrl: paymentFlowUrl, loading: urlLoading, error: urlErr } = (0, $8JJsY.useBillingUrls)(canSkipBillingUrl);
    const bannerType = licenseConsumingUserCount > $8348e7541d13687e$var$FREE_USER_LIMIT ? 'non-compliant' : 'compliant';
    // `TrialDetailsQuery` can throw Permission exception if initiater doesn't have sufficient permission
    // Permission error in this case is expected and FE should handle it gracefully - "markErrorAsHandled" and abort the experience instead of reporting as failures.
    if (trialError && (0, $1uFM6.isUnauthorizedError)(trialError)) {
        (0, $7Sm4c.markErrorAsHandled)(trialError);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $a1uvs.ExperienceAbort), {
            name: (0, $irVI7.ONBOARDING_GRACE_PERIOD_BANNER_EXPERIENCE),
            reason: "Aborted due to insufficient permission"
        });
    }
    // the queries are dependent and only one error should occur at a time
    const error = commerceBackendNameError || onboardingStateError || trialError || predunningError || urlErr || billingErr || isReverseTrialerError || pspUrlError || useAutoUpgradeNotATrialExperimentError;
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gfIPU.ExperienceFailure), {
        name: (0, $irVI7.ONBOARDING_GRACE_PERIOD_BANNER_EXPERIENCE),
        error: error,
        attributes: {
            isSiteAdmin: isSiteAdmin,
            commerceBackendName: commerceBackendName,
            licenseConsumingUserCount: licenseConsumingUserCount,
            isPreDunningPeriod: isPreDunningPeriod,
            bannerType: bannerType,
            daysLeftUntilDeactivation: preDunningDeactivationDate?.daysLeftUntilDeactivation,
            trialDaysLeft: trialDaysLeft
        }
    });
    const isLoading = commerceBackendNameLoading || trialLoading || predunningLoading || urlLoading || onboardingStateLoading || isReverseTrialLoading || billingLoading || isPSPUrlLoading || useAutoUpgradeNotATrialExperimentLoading;
    if (canSkipTrialDetails || isLoading || !premiumReverseTrialABCohort || // Auto Upgrade Not a Trial Experiment Grace Period Banner is shown to sites that are in trial and in pre-dunning
    !isPreDunningPeriod && autoUpgradeNotATrialExperimentCohort !== 'treatment' || !deactivationDate || !paymentFlowUrl || // compliant banner dismissal
    !isOverFreeLimit && trialGracePeriodBannerDismissed) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $hrAmX.BannerStateContainer)
        ]
    }, (bannerState)=>{
        const bannerHeight = isOverFreeLimit ? $8348e7541d13687e$export$2eff8595d3cf14d9 : $8348e7541d13687e$export$16263d008de82112;
        bannerState?.show($8348e7541d13687e$var$BANNER_NAME, bannerHeight);
        (0, $cbc8g.addUFOCustomData)({
            isGracePeriodBannerDisplayed: true
        });
        if (autoUpgradeNotATrialExperimentCohort === 'treatment') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $31d8c74f6a420dc4$export$efca1d277cbcb6a), {
            cloudId: cloudId
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
            name: (0, $irVI7.ONBOARDING_GRACE_PERIOD_BANNER_EXPERIENCE),
            attributes: {
                bannerType: bannerType,
                autoUpgradeNotATrialExperimentCohort: autoUpgradeNotATrialExperimentCohort,
                trialDaysLeft: trialDaysLeft,
                daysLeftUntilDeactivation: preDunningDeactivationDate?.daysLeftUntilDeactivation
            }
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, isOverFreeLimit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ec4f0bb7d2875a45$export$c715243965c2f8cf), {
            linkToAddBilling: paymentFlowUrl,
            deactivationDate: deactivationDate.dateString,
            numberOfUsersOverFreeLimit: numberOfUsersOverFreeLimit,
            licenseConsumingUserCount: licenseConsumingUserCount,
            edition: edition,
            premiumReverseTrialABCohort: premiumReverseTrialABCohort,
            linkToChoosePlan: planSelectionPageUrl
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b7ccc1702405ac49$export$f65c9f2c373ce883), {
            linkToAddBilling: paymentFlowUrl,
            daysLeftUntilDeactivation: preDunningDeactivationDate?.daysLeftUntilDeactivation,
            licenseConsumingUserCount: licenseConsumingUserCount,
            edition: edition,
            hideBanner: ()=>bannerState?.hide($8348e7541d13687e$var$BANNER_NAME),
            premiumReverseTrialABCohort: premiumReverseTrialABCohort,
            linkToChoosePlan: planSelectionPageUrl
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
            name: (0, $irVI7.ONBOARDING_GRACE_PERIOD_BANNER_EXPERIENCE),
            attributes: {
                bannerType: bannerType,
                autoUpgradeNotATrialExperimentCohort: autoUpgradeNotATrialExperimentCohort,
                daysLeftUntilDeactivation: preDunningDeactivationDate?.daysLeftUntilDeactivation,
                trialDaysLeft: trialDaysLeft
            }
        }));
    });
};
const $8348e7541d13687e$export$25e97e90a802d73 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hSqtY.TransparentErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).GROWTH_LUNA
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8348e7541d13687e$export$b7f0db819db4d29e, null));
};
module.exports["NON_COMPLIANT_BANNER_HEIGHT"] = $8348e7541d13687e$export$2eff8595d3cf14d9;
module.exports["COMPLIANT_BANNER_HEIGHT"] = $8348e7541d13687e$export$16263d008de82112;
module.exports["BannerComponent"] = $8348e7541d13687e$export$b7f0db819db4d29e;
module.exports["GracePeriodBanner"] = $8348e7541d13687e$export$25e97e90a802d73;

});

parcelRegister("a1uvs", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $1kHsc = parcelRequire("1kHsc");

function $5da8a4a03d184e93$export$c9b6bcd70239a39c(t0) {
    const $ = (0, $frIzR.c)(5);
    const { name: name, reason: reason } = t0;
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    let t2;
    if ($[0] !== experienceTracker || $[1] !== name || $[2] !== reason) {
        t1 = ()=>experienceTracker.abort({
                name: name,
                reason: reason
            });
        t2 = [
            name,
            reason,
            experienceTracker
        ];
        $[0] = experienceTracker;
        $[1] = name;
        $[2] = reason;
        $[3] = t1;
        $[4] = t2;
    } else {
        t1 = $[3];
        t2 = $[4];
    }
    (0, $42omo.useEffect)(t1, t2);
    return null;
}
module.exports["ExperienceAbort"] = $5da8a4a03d184e93$export$c9b6bcd70239a39c;

});

parcelRegister("gqp7m", function(module, exports) {
/**
 * @Relay no-runtime
 */ /**
 * @graphql agg
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $xQxzY = parcelRequire("xQxzY");


var $bQm3c = parcelRequire("bQm3c");


var $1ytiN = parcelRequire("1ytiN");


var $gKr8t = parcelRequire("gKr8t");


var $7Sm4c = parcelRequire("7Sm4c");


var $1uFM6 = parcelRequire("1uFM6");


var $f9jv7 = parcelRequire("f9jv7");


var $bFDX4 = parcelRequire("bFDX4");

const $211f773a291d5685$export$b4b101074ba9b8a2 = (skip = false)=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    const shouldSkip = skip || !isSiteAdmin || !cloudId;
    const { data: data, loading: loading, error: queryError } = (0, $xQxzY.useQuery)((0, $eSUdr.default)`query useHasBillingInformationIsAccountInvoiceableQuery($cloudId:ID!$hamsProductKey:String!){tenantContexts(cloudIds:[$cloudId]){entitlementInfo(hamsProductKey:$hamsProductKey){...on CommerceEntitlementInfoCcp{entitlementId entitlement{...on CcpEntitlement{id subscription{...on CcpSubscription{id accountDetails{invoiceGroup{invoiceable id}}}}}}}}}}`, {
        variables: {
            cloudId: cloudId,
            hamsProductKey: 'confluence.ondemand'
        },
        skip: shouldSkip,
        client: (0, $gKr8t.getAGGClient)()
    });
    if (shouldSkip) return {
        hasBillingInformation: false,
        loading: false,
        error: null
    };
    let hasBillingInformation = false;
    let error = queryError || null;
    if (!loading) {
        if (queryError) // unauthorized, not found, too many requests errors are expected
        {
            if ((0, $1uFM6.isUnauthorizedError)(queryError) || (0, $f9jv7.isNotFoundError)(queryError) || (0, $bFDX4.isTooManyRequestsError)(queryError) || $211f773a291d5685$var$isGraphQLTooManyRequestsError(queryError)) {
                (0, $7Sm4c.markErrorAsHandled)(queryError);
                error = null;
            }
        } else hasBillingInformation = data?.tenantContexts?.[0]?.entitlementInfo?.entitlement?.subscription?.accountDetails?.invoiceGroup?.invoiceable ?? false;
    }
    return {
        hasBillingInformation: hasBillingInformation,
        loading: loading,
        error: error
    };
};
/**
 * Checks if the provided error is a GraphQL error indicating a "429 Too Many Requests" scenario.
 *
 * In GraphQL, it's common for the HTTP response status to be 200 OK even when there are
 * application-level errors. This function helps identify "Too Many Requests" errors that
 * might be returned from a downstream service but are wrapped in a GraphQL response.
 *
 * @param error - The error object to inspect. It could be an ApolloErrorInterop or a generic error.
 * @returns {boolean} - Returns true if the error message contains an indication of a "429 Too Many Requests" error.
 */ const $211f773a291d5685$var$isGraphQLTooManyRequestsError = (error)=>{
    if (error && error.message) return error.message.includes('GraphQL error: [429 Too Many Requests]');
    return false;
};
module.exports["useHasBillingInformation"] = $211f773a291d5685$export$b4b101074ba9b8a2;

});

parcelRegister("f9jv7", function(module, exports) {

var $aMcHK = parcelRequire("aMcHK");

const $b29e4bf652226e80$export$6ccdb59d3479f4f1 = (error)=>(0, $aMcHK.isStatusCodeError)(error, '404');
module.exports["isNotFoundError"] = $b29e4bf652226e80$export$6ccdb59d3479f4f1;

});

parcelRegister("bFDX4", function(module, exports) {

var $aMcHK = parcelRequire("aMcHK");

const $8182af0d2f396edd$export$5df30e64c619846d = (error)=>(0, $aMcHK.isStatusCodeError)(error, '429');
module.exports["isTooManyRequestsError"] = $8182af0d2f396edd$export$5df30e64c619846d;

});

parcelRegister("hY10E", function(module, exports) {
/**
 * @Relay no-runtime
 */ /**
 * @graphql cc
 */ 
var $eSUdr = parcelRequire("eSUdr");


var $42omo = parcelRequire("42omo");


var $xQxzY = parcelRequire("xQxzY");


var $917iu = parcelRequire("917iu");


var $bQm3c = parcelRequire("bQm3c");


var $9wGTI = parcelRequire("9wGTI");


var $1ytiN = parcelRequire("1ytiN");


var $euL71 = parcelRequire("euL71");


var $kAcNG = parcelRequire("kAcNG");


var $a119A = parcelRequire("a119A");

const $8853af7e8236bde8$export$4695bad538a258b4 = ()=>{
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    const isPremium = edition === (0, $euL71.ConfluenceEdition).PREMIUM;
    const { isSiteAdmin: isSiteAdmin } = (0, $42omo.useContext)((0, $1ytiN.SPAViewContext));
    // SignUpProperties that are sent from BXP
    const { isReverseTrialer: isReverseTrialer, loading: loading, error: error } = $8853af7e8236bde8$export$153e1a2894ed595({
        skip: !isSiteAdmin || !isPremium
    });
    // Master FF to quickly enable / disable all Onboarding Experiences
    const isReverseTrialEligibleUser = isSiteAdmin && isPremium && (0, $9wGTI.fg)('cc_onboarding_experience');
    const isReverseTrialTreatmentCohort = !loading && !error && isReverseTrialer;
    return {
        isReverseTrialEligible: isReverseTrialEligibleUser && isReverseTrialTreatmentCohort
    };
};
function $8853af7e8236bde8$export$153e1a2894ed595({ skip: skip } = {}) {
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { data: reverseTrialData, loading: isReverseTrialLoading, error: reverseTrialError } = (0, $xQxzY.useQuery)((0, $eSUdr.default)`query useReverseTrialEligibleSignUpPropertiesQuery{signUpProperties{reverseTrial}}`, {
        skip: skip
    });
    const { loading: isSitePersonalizationLoading, error: sitePersonalizationError, attributes: attributes } = (0, $kAcNG.useSitePersonalizationQuery)({
        cloudId: cloudId,
        skip: skip
    });
    const TRIAL_PERIOD_DAYS = 45;
    let isWithinFirstTrialPeriod = true; // Default to true because if the activation date is not available, this means that the site was recently provisioned
    const activationDateAttr = attributes?.find((attr)=>attr.name === 'confluence.ondemand.activationDate');
    if (activationDateAttr && activationDateAttr.value) {
        const activationDate = new Date(activationDateAttr.value);
        const daysSinceActivation = (0, $917iu.default)(new Date(), activationDate);
        isWithinFirstTrialPeriod = daysSinceActivation <= TRIAL_PERIOD_DAYS;
    }
    const reverseTrialCohort = reverseTrialData?.signUpProperties?.reverseTrial;
    return {
        isReverseTrialer: isWithinFirstTrialPeriod && reverseTrialCohort === (0, $a119A.ReverseTrialCohort).ENROLLED,
        reverseTrialCohort: reverseTrialCohort,
        loading: skip ? false : isReverseTrialLoading || isSitePersonalizationLoading,
        error: skip ? null : reverseTrialError || sitePersonalizationError
    };
}
module.exports["useReverseTrialCohort"] = $8853af7e8236bde8$export$153e1a2894ed595;

});

parcelRegister("a119A", function(module, exports) {
/**
 * @generated SignedSource<<7c96ffe5db93bb7b8bc74d6411281d3b>>
 * This file was auto-generated by a codemod
 * @see https://go/connie-relay-migration-fyi
 **/ var $15e6aec9d603aba5$export$8798225e6f84b893 = /*#__PURE__*/ function(ReverseTrialCohort) {
    ReverseTrialCohort["CONTROL"] = "CONTROL";
    ReverseTrialCohort["ENROLLED"] = "ENROLLED";
    ReverseTrialCohort["NOT_ENROLLED"] = "NOT_ENROLLED";
    ReverseTrialCohort["UNASSIGNED"] = "UNASSIGNED";
    ReverseTrialCohort["UNKNOWN"] = "UNKNOWN";
    ReverseTrialCohort["VARIANT"] = "VARIANT";
    return ReverseTrialCohort;
}({});
module.exports["ReverseTrialCohort"] = $15e6aec9d603aba5$export$8798225e6f84b893;

});

parcelRegister("53qVZ", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $ebrpi = parcelRequire("ebrpi");

const $d973bb5650e905e2$var$BannerContentContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(8);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const t3 = `${__cmplp.height}px`;
        let t4;
        if ($[3] !== t3) {
            t4 = (0, $7sObp.default)(t3);
            $[3] = t3;
            $[4] = t4;
        } else t4 = $[4];
        let t5;
        if ($[5] !== __cmpls || $[6] !== t4) {
            t5 = {
                ...__cmpls,
                "--_1neqek2": t4
            };
            $[5] = __cmpls;
            $[6] = t4;
            $[7] = t5;
        } else t5 = $[7];
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
            ...__cmplp,
            style: t5,
            ref: __cmplr,
            className: (0, $gMc0m.default)([
                "_11q71917 _1yt4utpp _zulp1b66 _1e0c1txw _1bah1h6o _4cvr1h6o _syazi7uo _4t3i2nrh _vchhusvi",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
const $d973bb5650e905e2$export$aa2fe30df074b213 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "a" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_4bfu1r31 _1hms8stv _ajmmnqa1 _syazi7uo _80omtlke _o5721q9c _d16pv77o _7b0b1i6y _30l3i7uo _1053i7uo",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $d973bb5650e905e2$var$TextContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _zulp1b66 _1e0c1txw _4cvr1h6o _k48p1wq8",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $d973bb5650e905e2$var$DescriptionContainer = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1reo15vq _18m915vq _o5721q9c _1bto1l2s",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $d973bb5650e905e2$var$i18n = (0, $cgtv4.defineMessages)({
    warningIcon: {
        id: "banners.icons.warning",
        defaultMessage: "Warning icon"
    },
    moreIcon: {
        id: "banners.icons.more",
        defaultMessage: "More icon"
    },
    closeIcon: {
        id: "banners.icons.close",
        defaultMessage: "Close icon"
    }
});
const $d973bb5650e905e2$export$81bad57c302cbb8f = (t0)=>{
    const $ = (0, $frIzR.c)(14);
    const { bannerHeight: bannerHeight, description: description, inlineDescriptionCTA: inlineDescriptionCTA, rightSideComponent: rightSideComponent } = t0;
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    let t1;
    if ($[0] !== formatMessage) {
        t1 = formatMessage($d973bb5650e905e2$var$i18n.warningIcon);
        $[0] = formatMessage;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ebrpi))), {
            spacing: "spacious",
            label: t1,
            color: "var(--ds-icon-warning, #E06C00)"
        });
        $[2] = t1;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== description) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d973bb5650e905e2$var$DescriptionContainer, null, description);
        $[4] = description;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== inlineDescriptionCTA || $[7] !== t2 || $[8] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d973bb5650e905e2$var$TextContainer, null, t2, t3, inlineDescriptionCTA);
        $[6] = inlineDescriptionCTA;
        $[7] = t2;
        $[8] = t3;
        $[9] = t4;
    } else t4 = $[9];
    let t5;
    if ($[10] !== bannerHeight || $[11] !== rightSideComponent || $[12] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($d973bb5650e905e2$var$BannerContentContainer, {
            height: bannerHeight
        }, t4, rightSideComponent);
        $[10] = bannerHeight;
        $[11] = rightSideComponent;
        $[12] = t4;
        $[13] = t5;
    } else t5 = $[13];
    return t5;
};
module.exports["BannerLink"] = $d973bb5650e905e2$export$aa2fe30df074b213;
module.exports["OnboardingWarningBanner"] = $d973bb5650e905e2$export$81bad57c302cbb8f;

});

parcelRegister("5EhYK", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $3pfAb = parcelRequire("3pfAb");


var $inPa6 = parcelRequire("inPa6");


var $8hmrm = parcelRequire("8hmrm");

var $gwZbZ = parcelRequire("gwZbZ");

var $6o7wX = parcelRequire("6o7wX");


var $dhYWb = parcelRequire("dhYWb");

const $b6e61a181e3b095b$export$85183a312807388d = (0, $3pfAb.FabricChannel).growth;
function $b6e61a181e3b095b$export$e955abb82869dc84() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const sendAnalyticEvent = (0, $42omo.useCallback)((payload)=>{
        createAnalyticsEvent(payload).fire($b6e61a181e3b095b$export$85183a312807388d);
    }, [
        createAnalyticsEvent
    ]);
    const createAddPaymentsButtonClickEvent = (source, attributes)=>sendAnalyticEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: (0, $dhYWb.ADD_PAYMENT_AVOID_DEACTIVATION_ACTION_SUBJECT_ID),
            source: source,
            attributes: attributes
        });
    const createTakeActionClickEvent = (sourceId, attributes)=>sendAnalyticEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: (0, $dhYWb.TAKE_ACTION_AVOID_DEACTIVATION_ACTION_SUBJECT_ID),
            source: sourceId,
            attributes: attributes
        });
    const createRemoveUsersButtonClickEvent = (sourceId, attributes)=>sendAnalyticEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: (0, $dhYWb.REMOVE_USERS_AVOID_DEACTIVATION_ACTION_SUBJECT_ID),
            source: sourceId,
            attributes: attributes
        });
    const growthErrorHandler = ({ error: error, errorInfo: errorInfo, product: product, source: source })=>sendAnalyticEvent((0, $8hmrm.createProductSpecificAnalyticsIntegrationPayload)({
            team: (0, $6o7wX.Team).GROWTH_LUNA,
            product: product === 'confluence' ? (0, $gwZbZ.Product).CONFLUENCE : (0, $gwZbZ.Product).JIRA,
            experimentMeta: {
                experimentKey: (0, $dhYWb.AUNT_STATSIG_EXPERIMENT_KEY)
            },
            errorMessage: error.message,
            errorType: (0, $gwZbZ.ErrorType).GENERIC,
            source: source || (0, $dhYWb.AUNT_STATSIG_EXPERIMENT_KEY),
            severity: (0, $gwZbZ.Severity).HIGH,
            additionalAttributes: {
                ...errorInfo
            }
        }));
    return {
        sendAnalyticEvent: sendAnalyticEvent,
        createAddPaymentsButtonClickEvent: createAddPaymentsButtonClickEvent,
        createRemoveUsersButtonClickEvent: createRemoveUsersButtonClickEvent,
        createTakeActionClickEvent: createTakeActionClickEvent,
        growthErrorHandler: growthErrorHandler
    };
}
function $b6e61a181e3b095b$export$b901544a79a3bbad({ name: name, attributes: attributes }) {
    const { sendAnalyticEvent: sendAnalyticEvent } = $b6e61a181e3b095b$export$e955abb82869dc84();
    const hasSentScreenEvent = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        if (hasSentScreenEvent.current) return;
        sendAnalyticEvent({
            eventType: 'screen',
            name: name,
            attributes: attributes
        });
    }, [
        sendAnalyticEvent,
        name,
        attributes
    ]);
    return null;
}
module.exports["useAnalytics"] = $b6e61a181e3b095b$export$e955abb82869dc84;
module.exports["ScreenEvent"] = $b6e61a181e3b095b$export$b901544a79a3bbad;

});

parcelRegister("dhYWb", function(module, exports) {
const $9336b0b8d90394bf$export$7af15fb4b1ef8bf2 = 'auto_upgrade_not_a_trial';
const $9336b0b8d90394bf$export$31c76e063a58551f = 14;
const $9336b0b8d90394bf$export$e25ee5e8d56c9434 = 'auto-upgrade-avoid-deactivation-modal';
const $9336b0b8d90394bf$export$4c68c8f979e7c34e = 'autoUpgradeAvoidDeactivationModal';
const $9336b0b8d90394bf$export$e1dd560345bb2391 = 'autoUpgradeAvoidDeactivationBanner';
const $9336b0b8d90394bf$export$fb4037ac52e8f2af = 'auto-upgrade-avoid-deactivation-banner';
const $9336b0b8d90394bf$export$605e10c7fb710fe8 = 'auto-upgrade-avoid-deactivation-flag';
const $9336b0b8d90394bf$export$617971661581b89a = 'addPaymentAvoidDeactivation';
const $9336b0b8d90394bf$export$6b183dcf8256b901 = 'removeUsersAvoidDeactivation';
const $9336b0b8d90394bf$export$88ddc07ee0185a0 = 'autoUpgradeNotATrial';
const $9336b0b8d90394bf$export$4bdf96a244b85ff6 = 'autoUpgradeNotATrial';
const $9336b0b8d90394bf$export$6be2b9eb165d621f = 44;
const $9336b0b8d90394bf$export$51039dd19c9a3762 = {
    confluence: 10,
    'jira-product-discovery': 3,
    'jira-service-management': 3,
    jira: 10
};
const $9336b0b8d90394bf$export$466cbff150b55117 = {
    ['confluence']: 'user',
    ['jira']: 'user',
    ['jira-product-discovery']: 'creator',
    ['jira-service-management']: 'agent'
};
const $9336b0b8d90394bf$export$5a01ec5e3068630c = {
    ['confluence']: 'confluence',
    ['jira']: 'jira',
    ['jira-product-discovery']: 'jira',
    ['jira-service-management']: 'jira'
};
const $9336b0b8d90394bf$export$c17ca73287ae9119 = {
    ['confluence']: 'confluence',
    ['jira']: 'jira-software',
    ['jira-product-discovery']: 'jira-product-discovery',
    ['jira-service-management']: 'jira-servicedesk'
};
module.exports["AUNT_STATSIG_EXPERIMENT_KEY"] = $9336b0b8d90394bf$export$7af15fb4b1ef8bf2;
module.exports["STANDARD_TRIAL_DAYS_TO_DEACTIVATION"] = $9336b0b8d90394bf$export$31c76e063a58551f;
module.exports["AVOID_DEACTIVATION_MODAL_TEST_ID"] = $9336b0b8d90394bf$export$e25ee5e8d56c9434;
module.exports["AVOID_DEACTIVATION_MODAL_ACTION_SUBJECT_ID"] = $9336b0b8d90394bf$export$4c68c8f979e7c34e;
module.exports["AVOID_DEACTIVATION_BANNER_SUBJECT_ID"] = $9336b0b8d90394bf$export$e1dd560345bb2391;
module.exports["AVOID_DEACTIVATION_BANNER_TEST_ID"] = $9336b0b8d90394bf$export$fb4037ac52e8f2af;
module.exports["ADD_PAYMENT_AVOID_DEACTIVATION_ACTION_SUBJECT_ID"] = $9336b0b8d90394bf$export$617971661581b89a;
module.exports["REMOVE_USERS_AVOID_DEACTIVATION_ACTION_SUBJECT_ID"] = $9336b0b8d90394bf$export$6b183dcf8256b901;
module.exports["TAKE_ACTION_AVOID_DEACTIVATION_ACTION_SUBJECT_ID"] = $9336b0b8d90394bf$export$88ddc07ee0185a0;
module.exports["TAKE_ACTION_SOURCE_ID"] = $9336b0b8d90394bf$export$4bdf96a244b85ff6;
module.exports["MAX_USERS_ON_FREE_PLAN"] = $9336b0b8d90394bf$export$51039dd19c9a3762;
module.exports["PRODUCT_TO_CHARGE_ELEMENT"] = $9336b0b8d90394bf$export$466cbff150b55117;
module.exports["PRODUCT_TO_ORIGIN"] = $9336b0b8d90394bf$export$5a01ec5e3068630c;
module.exports["ProductKeyToHAMSMap"] = $9336b0b8d90394bf$export$c17ca73287ae9119;

});

parcelRegister("b0bCf", function(module, exports) {

var $dhYWb = parcelRequire("dhYWb");

const $e5eb9cf773a94bba$export$68b898ecc084962 = (product)=>{
    return {
        chargeElementSingular: (0, $dhYWb.PRODUCT_TO_CHARGE_ELEMENT)[product],
        chargeElementPlural: (0, $dhYWb.PRODUCT_TO_CHARGE_ELEMENT)[product] + 's'
    };
};
const $e5eb9cf773a94bba$export$291d012eb0744b34 = (product)=>{
    return (0, $dhYWb.ProductKeyToHAMSMap)[product];
};
const $e5eb9cf773a94bba$export$8e8e465e66e8e161 = (product)=>{
    switch(product){
        case 'jira':
            return 'Jira';
        case 'jira-service-management':
            return 'Jira Service Management';
        case 'jira-product-discovery':
            return 'Jira Product Discovery';
        case 'confluence':
            return 'Confluence';
        default:
            return '';
    }
};
module.exports["getChargeElementTypeByProduct"] = $e5eb9cf773a94bba$export$68b898ecc084962;
module.exports["getHamsKey"] = $e5eb9cf773a94bba$export$291d012eb0744b34;
module.exports["getProductNameFromProductKey"] = $e5eb9cf773a94bba$export$8e8e465e66e8e161;

});

parcelRegister("fAD9L", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $6xdDU = parcelRequire("6xdDU");


var $TSbNa = parcelRequire("TSbNa");

const $71b8fe84901d80f2$var$RenderModal = ({ modal: modal })=>{
    const [shouldCloseOnOverlayClick, setShouldCloseOnOverlayClick] = (0, $42omo.useState)();
    const [shouldCloseOnEscapePress, setShouldCloseOnEscapePress] = (0, $42omo.useState)();
    const Component = modal.component;
    return /*#__PURE__*/ (0, $l998X.jsx)(Component, {
        onClose: modal.close,
        shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
        shouldCloseOnEscapePress: shouldCloseOnEscapePress,
        setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick,
        setShouldCloseOnEscapePress: setShouldCloseOnEscapePress
    });
};
function $71b8fe84901d80f2$export$7c9538f5f3c365e9({ children: children }) {
    const id = (0, $42omo.useRef)(1);
    const [modals, setModals] = (0, $42omo.useState)([]);
    const modalContext = (0, $42omo.useMemo)(()=>({
            openModal: (component)=>{
                const key = String(id.current++);
                const close = ()=>{
                    setModals((mdls)=>mdls.filter((d)=>d.key !== key));
                };
                setModals((mdls)=>[
                        ...mdls,
                        {
                            close: close,
                            component: component,
                            key: key
                        }
                    ]);
            }
        }), []);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $TSbNa.ModalContext).Provider, {
        value: modalContext,
        children: [
            children,
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6xdDU.default), {
                children: modals.map((modal)=>/*#__PURE__*/ (0, $l998X.jsx)($71b8fe84901d80f2$var$RenderModal, {
                        modal: modal
                    }, modal.key))
            })
        ]
    });
}
module.exports["ModalContextProvider"] = $71b8fe84901d80f2$export$7c9538f5f3c365e9;

});

parcelRegister("TSbNa", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $645b684711965e78$export$ab57792b9b6974a6 = (0, $42omo.createContext)({
    openModal: ()=>{
        throw new Error("To show the modal, wrap your app's root component with a <ModalContextProvider />. import { ModalContextProvider } from '@atlassian/entry-point-modal-context/ModalContextProvider';");
    }
});
module.exports["ModalContext"] = $645b684711965e78$export$ab57792b9b6974a6;

});

parcelRegister("7wGk4", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $fBMbo = parcelRequire("fBMbo");


var $irOoi = parcelRequire("irOoi");


var $iP9n7 = parcelRequire("iP9n7");


var $cQDYl = parcelRequire("cQDYl");


var $8CZUH = parcelRequire("8CZUH");

var $1DHa6 = parcelRequire("1DHa6");

var $8o1lj = parcelRequire("8o1lj");

var $9ot3w = parcelRequire("9ot3w");

var $d8eRd = parcelRequire("d8eRd");


var $dh538 = parcelRequire("dh538");


var $eyWa4 = parcelRequire("eyWa4");


var $4M6GB = parcelRequire("4M6GB");


var $TSbNa = parcelRequire("TSbNa");


var $7wYo8 = parcelRequire("7wYo8");


var $48FEk = parcelRequire("48FEk");


var $gWF6I = parcelRequire("gWF6I");

const $abc57e0f1f470075$var$emptyEntryPointParams = {};
const $abc57e0f1f470075$var$emptyEntryPointProps = {};
function $abc57e0f1f470075$export$fb10b32cfe19f1e({ children: children, entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, Fallback: Fallback, title: title, modalProps: modalProps, forwardedRef: forwardedRef, onError: onError, preloadOnFocus: providedPreloadOnFocus }) {
    (0, $fBMbo.di)((0, $irOoi.loadEntryPoint));
    const { openModal: openModal } = (0, $42omo.useContext)((0, $TSbNa.ModalContext));
    const environmentProvider = (0, $gWF6I.useRelayEnvironmentProvider)();
    const { ModalErrorFallback: ModalErrorFallback } = (0, $4M6GB.useEntryPointConfig)();
    const preloadOnFocus = providedPreloadOnFocus ?? (0, $dh538.fg)('dst-a11y_preload-on-focus-default-true') ? true : false;
    const metricName = (0, $42omo.useMemo)(()=>{
        return entryPoint.root.getModuleName() || 'unknown';
    }, [
        entryPoint
    ]);
    const load = (0, $42omo.useCallback)(()=>(0, $irOoi.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams ?? $abc57e0f1f470075$var$emptyEntryPointParams), [
        entryPoint,
        entryPointParams,
        environmentProvider
    ]);
    const onLoad = (0, $42omo.useCallback)(({ reference: entryPointReference, dispose: dispose })=>{
        openModal(({ onClose: closeModal, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick, shouldCloseOnEscapePress: shouldCloseOnEscapePress, setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick, setShouldCloseOnEscapePress: setShouldCloseOnEscapePress })=>{
            const onClose = (extraInformation)=>{
                entryPointProps?.onClose?.(extraInformation);
                closeModal();
                dispose();
            };
            const defaultFallback = /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $9ot3w.default), {
                        children: title ? /*#__PURE__*/ (0, $l998X.jsx)((0, $d8eRd.default), {
                            children: title
                        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
                            grow: "fill",
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $cQDYl.default), {})
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $1DHa6.default), {
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $cQDYl.default), {}),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $cQDYl.default), {}),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $cQDYl.default), {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $8o1lj.default), {})
                ]
            });
            const container = /*#__PURE__*/ (0, $l998X.jsx)((0, $48FEk.InternalEntryPointContainer), {
                entryPointReference: entryPointReference,
                errorFallback: ({ error: error })=>/*#__PURE__*/ (0, $l998X.jsx)(ModalErrorFallback, {
                        error: error
                    }),
                onError: ({ error: error, errorInfo: errorInfo })=>{
                    onError?.({
                        error: error,
                        errorInfo: errorInfo
                    });
                    closeModal();
                },
                fallback: Fallback ? /*#__PURE__*/ (0, $l998X.jsx)(Fallback, {
                    onClose: closeModal
                }) : defaultFallback,
                id: metricName,
                placeholderName: "modal-entry-point-pressable-trigger-container",
                runtimeProps: {
                    ...entryPointProps ?? $abc57e0f1f470075$var$emptyEntryPointProps,
                    onClose: onClose,
                    setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick,
                    setShouldCloseOnEscapePress: setShouldCloseOnEscapePress,
                    shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
                    shouldCloseOnEscapePress: shouldCloseOnEscapePress
                }
            });
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $8CZUH.default), {
                ...modalProps,
                onClose: onClose,
                shouldCloseOnOverlayClick: shouldCloseOnOverlayClick ?? modalProps?.shouldCloseOnOverlayClick,
                shouldCloseOnEscapePress: shouldCloseOnEscapePress ?? modalProps?.shouldCloseOnEscapePress,
                children: container
            });
        });
    }, [
        openModal,
        title,
        modalProps,
        Fallback,
        metricName,
        entryPointProps,
        ModalErrorFallback,
        onError
    ]);
    const triggerRef = (0, $7wYo8.usePressablePreloadRef)({
        load: load,
        onLoad: onLoad,
        preloadOnFocus: preloadOnFocus
    });
    const mergedRef = (0, $iP9n7.useMergeRefs)([
        triggerRef,
        forwardedRef || null
    ]);
    return children({
        ref: mergedRef
    });
}
module.exports["ModalTrigger"] = $abc57e0f1f470075$export$fb10b32cfe19f1e;

});

parcelRegister("bJq0d", function(module, exports) {
var $cdac08834664f9ea$export$23e8f571dd61cd8c = /*#__PURE__*/ function(MPU_QUERY) {
    MPU_QUERY["HAMS_PRODUCT_KEY"] = "confluence.ondemand";
    MPU_QUERY["OFFERING_KEY"] = "2eda1119-fab4-4699-ab37-ff8f12052cde";
    return MPU_QUERY;
}({});
module.exports["MPU_QUERY"] = $cdac08834664f9ea$export$23e8f571dd61cd8c;

});


//# sourceMappingURL=GracePeriodBanner.4ed2745f.js.map
